import React from 'react';
import InputTimePicker, {
  Props as InputProps,
} from '@teetsh/app/src/components/Form/TimePicker2/InputTimePicker';
import FormGroup from '@teetsh/app/src/components/Form/FormGroup';

export interface AdditionalProps {
  inline?: boolean;
  helperText?: string;
  showArrowButtons?: boolean;
  label?: string;
  error?: string;
  withoutMargin?: boolean;
}

export type Props = AdditionalProps & InputProps;

export default function TimePicker2Wrapper(props: Props) {
  const { error, helperText, withoutMargin, id, ...rest } = props;
  return (
    <FormGroup
      id={id}
      helperText={error || helperText}
      withoutMargin={withoutMargin}
    >
      <InputTimePicker id={id} {...rest} />
    </FormGroup>
  );
}
